import React from 'react';
import Link from 'next/link';
import { Card, Input, Select } from '@avila-tek/ui/src';
import { PromoCode } from '../../../models/index';
import FormHeader from '../../shared/Forms/FormHeader';

interface SaleFormFieldsProps {
  formState: Partial<PromoCode>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<PromoCode>>>;
}

function SaleFormFields({ formState, setFormState }: SaleFormFieldsProps) {
  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();
    const { value, name } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  return (
    <Card>
      <FormHeader
        href="/app/maintenance/sales"
        backBtnText="Promociones"
        title={
          formState._id
            ? 'Actualizar código promocional'
            : 'Crear código promocional'
        }
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Input
              name="name"
              value={formState.name ?? ''}
              label="Nombre"
              type="text"
              placeholder="Ingrese un nombre"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full">
            <Select
              name="type"
              value={formState.type ?? ''}
              label="Tipo de descuento"
              onChange={handleInputChange}
              required
            >
              <option value="" disabled>
                Seleccione un tipo de descuento
              </option>
              <option value="fixed">Fijo</option>
              <option value="percentage">Porcentual</option>
            </Select>
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Input
              name="value"
              value={formState?.value ?? ''}
              label="Modificador"
              type="number"
              placeholder="Ingrese un número modificador"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="w-full">
            <Input
              name="code"
              value={formState?.code ?? ''}
              label="Código promocional"
              type="text"
              placeholder="Ingrese un código promocional"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default SaleFormFields;
